import React from 'react';
import { Box, Container } from '@mui/material';
import BackButton from 'components/common/buttons/BackButton';

/**
 * Higher-order component that wraps page content with consistent layout
 * including back button and proper spacing
 */
const PageWrapper = ({ 
  children, 
  showBackButton = true, 
  backButtonProps = {},
  containerProps = {},
  ...props 
}) => {
  return (
    <Container 
      maxWidth="lg" 
      sx={{ 
        mt: 2, 
        mb: 4, 
        position: 'relative',
        ...containerProps.sx 
      }}
      {...containerProps}
    >
      {showBackButton && (
        <BackButton {...backButtonProps} />
      )}
      <Box sx={{ position: 'relative' }} {...props}>
        {children}
      </Box>
    </Container>
  );
};

export default PageWrapper;